@if (model) {
  <div>
    <app-sem-dynamic-control #dynComp (ngModelChange)="modelChanged(model)" (change)="modelChanged(model)"
    [entity]="model" [ngModel]="model" [component]="this" [template]="boundComponent.content"></app-sem-dynamic-control>
  </div>
}